import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/admin-settings/dashboard")({
  component: lazyImportRouteComponent(
    () => import("./-components/DashboardSettingsPage"),
    "DashboardSettingsPage"
  ),
  beforeLoad: (context) => {
    return {
      getTitle: () =>
        context.context.t &&
        context.context.t("NavItem_DashboardKonfiguration"),
    }
  },
})
